import React from "react";
import { Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN } from "../../../store/actionTypes/bplrt/equipmentActionType";

const EquipmentErrorPrompt = () => {
  const dispatch = useDispatch();

  const {
    isErrorPromptEquipmentPage: isError,
    errorMessageEquipmentPage: errorMessage,
  } = useSelector((state) => state.bplrtEquip);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_EQUIPMENT_BREAKDOWN, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        {errorMessage}
      </Alert>
    )
  );
};

export default EquipmentErrorPrompt;
